import { trace } from 'owa-trace';

/**
 * Posts a x-window message to the host
 * to add a new account to the current hx instance.
 */
export function addNewAccount() {
    trace.verbose('adding hx account');
    let msg = {
        source: 'AccountUtil',
        action: 'AddAccount',
        args: {},
    };

    window.chrome!.webview!.postMessage(msg);
}
